


























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class AppBtnCollapse extends Vue {
  @Prop({ type: Boolean, default: false })
  collapsed!: boolean

  @Prop({ type: Boolean, default: true })
  enabled!: boolean

  @Prop({ type: Boolean, default: false })
  inLayout!: boolean

  // emitChange (value: boolean) {
  //   this.$emit('input', value)
  // }
}
